import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { COMPANY } from "@/lib/site";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");

    (async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(data);
        const dest = data.role === "admin" ? "/dashboard" : "/account";
        window.history.replaceState(null, "", dest);
        navigate(dest, { state: { user: data } });
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen royal-radial flex flex-col items-center justify-center gap-6" data-testid="auth-callback">
      <img src={COMPANY.logo} alt="crest" className="w-24 h-24 object-contain rounded-xl animate-float" />
      <div className="flex items-center gap-3 text-emerald-200 font-garamond text-lg tracking-wide">
        <span className="w-2 h-2 rounded-full bg-emerald-400 pulse-dot" />
        Establishing secure session…
      </div>
    </div>
  );
}
